import {
  Component,
  OnInit,
  NgZone
} from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { InsulationMaterialSizeModel } from '../../../../models/dictionaries/insulation-material-size.model';
import { MainPageService } from '../../../main-page.service';

@Component({
  selector: 'app-insulation-material-managment',
  template: `<div *ngIf="insulationMaterialData !== undefined && insulationMaterialData !== null">
    <div class="row" style="padding-left: 12px;">
        <b>Insulation Material:</b> &nbsp;{{insulationMaterialData.name}}</div>
    <button type="button" class="btn btn-danger red-button" (click)="returnHandler()">Return</button>
    <button type="submit" class="btn btn-primary save-button" [disabled]="ctrl.invalid" (click)="save()">Save</button>
    <div class="row">

        <div class="col-6" style="line-height: 30px; padding-top: 30px;">
            <div class="display-flex">
                <div class="col-2">Name:
                </div>
                <input type="text" class="col-4" [(ngModel)]="insulationMaterialData.name" #ctrl="ngModel" required>
                <br>
            </div>
            <div class="display-flex">
                <div class="col-2">Density:
                </div>
                <input type="text" class="col-4" [(ngModel)]="insulationMaterialData.density"> <span class="col-1">[mm]</span>
            </div>
        </div>
    </div>

    <div class="col-3">
        <kendo-grid style="border: none" [data]="insulationMaterialSizeGridData" (add)="addHandlerForSizeData($event)" (save)="saveHandlerForSizeData($event)"
            (cancel)="cancelHandlerForSizeData($event)" (edit)="editHandlerForSizeData($event)" (remove)="removeHandler($event)">
            <ng-template kendoGridToolbarTemplate>
                <div class="display-flex">
                    <button kendoGridAddCommand [disabled]="!canAddRowToSizeGrid" class="btn add-button light-steel-shadow" style="position: absolute; right: 15px;"
                        type="button" title="add">
                        <i class="fa fa-plus" click></i> Add</button>
                </div>
            </ng-template>
            <kendo-grid-column field="size" editor="editNumber" title="Size [mm]" width="50">
            </kendo-grid-column>
            <kendo-grid-column title="" width="60">
                <ng-template kendoGridCellTemplate>
                    <div class="display-flex">
                        <!--MAGIC DO NOT TOUCH DISABLE FUNCTION-->
                        <button kendoGridEditCommand [disabled]="!canAddRowToSizeGrid" class="attributesBtn" title="Edit">
                            <i class="material-icons">&#xE3C9;</i>
                        </button>
                        <button kendoGridRemoveCommand [disabled]="!canAddRowToSizeGrid" class="attributesBtn btn-remove" data-toggle="modal" data-target="#confirmationModal"
                            title="Remove">
                            <i class="material-icons">&#xE5CD;</i>
                        </button>
                        <button kendoGridSaveCommand class="attributesBtn" title="Save">
                            <i class="material-icons">&#xE876;</i>
                        </button>
                        <button kendoGridCancelCommand class="attributesBtn" title="Cancel">
                            <i class="material-icons">&#xE5C9;</i>
                        </button>
                    </div>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="confirmationModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Insulation Material Size?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" (click)="removeSize()">Delete</button>
            </div>
        </div>
    </div>
</div>`,
  styles: [`.regularObjectBorder{border-width:1px;border-style:solid}.justTopBorder{border-bottom:0;border-left:0;border-right:0}.justRightBorder{border-bottom:0;border-left:0;border-top:0}.justBottomBorder{border-right:0;border-left:0;border-top:0}#tabContent{font-size:11px;border-color:#dddd}.modal-label{width:168px}hr{margin-top:0}#variantsGrid{margin-left:17px;border-color:#dddd}.delete-button{height:23px;width:23px;margin-left:3px;background-color:#d0021b;color:#fff;font-size:12px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;border-radius:2px;cursor:pointer}.configure-button{height:23px;margin-left:3px;background-color:#4a8bb7;color:#fff;font-size:12px;padding:3px 14px;font-weight:300;letter-spacing:1.1px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;margin-bottom:6px;border-radius:2px;cursor:pointer}.configure-button:disabled{background-color:#999;cursor:default}.step-file{font-size:14px;text-align:center;margin-bottom:10px;font-weight:700}#stpFileDiv{margin-left:auto;margin-right:auto}#variantsTabGrid{border:0;margin-top:26px;border-top:1px solid #ddd}.extra-padding-top{padding-top:10px}.mat-header-cell{font-weight:700}.variantBtn{background-color:#ddd;border:none;padding:6px 18px;outline:0;color:#534f53;cursor:pointer}.variants-header{margin:28px 0 5px;display:flex;justify-content:space-between}.table-label{font-size:16px}.tableCurrentVariant{font-size:14px;border-color:#708090}.borderGray{border-color:#a9a9a9}.borderGray:last-child{border-right:none}.mat-header-row{border-color:#dddd}.highlighted{background-color:#fff!important}.display-flex{display:flex;align-items:center;margin-bottom:10px}.save-button{margin-right:10px}`]
})

export class InsulationMaterialManagmentComponent implements OnInit {
  public insulationMaterialData: any;
  public isInsulationMaterialNew: boolean = false;
  public stateSubject: Subject<any> = new Subject();
  public insulationMaterialSizeGridData: InsulationMaterialSizeModel[];
  public editedSizeData: InsulationMaterialSizeModel;
  public canAddRowToSizeGrid = true;
  private sizesOpenedGridRows: number = 0;
  public isSizesGridInChangeMode = false;
  public currentOpenRow: number;
  public formGroup: FormGroup;
  public rowNumber: number;
  private removeData: any;

  constructor(private mainPageService: MainPageService, private formBuilder: FormBuilder, private zone: NgZone) { }

  public ngOnInit(): void {
    this.insulationMaterialSizeGridData = [];
    this.mainPageService.deleteInsulationMaterialSizeSubject.subscribe((value) => {
      this.insulationMaterialSizeGridData = this.insulationMaterialSizeGridData.filter(x => x._id !== value);
    });
  }

  loadData(): void {
    this.mainPageService.loadInsulationMaterialSizes(this.insulationMaterialData.id).subscribe((response) => {
      this.insulationMaterialSizeGridData = response;
    });
  }

  public showManagmentPage(sender, isNew?) {
    this.insulationMaterialData = sender;
    if (isNew) {
      this.isInsulationMaterialNew = isNew;
    }
    this.loadData();
  }

  save(): void {
    this.mainPageService.updateInsulationMaterialInDb(JSON.stringify(this.insulationMaterialData)).subscribe((res) => { });
    if (this.isInsulationMaterialNew) {
      this.isInsulationMaterialNew = false;
    }
  }

  returnHandler() {
    if (this.isInsulationMaterialNew) {
      this.mainPageService.removeInsulationMaterial(this.insulationMaterialData._id).subscribe(() => { });
      this.mainPageService.deleteInsulationMaterialSubject.next(this.insulationMaterialData._id);
      this.insulationMaterialData = null;
    }
    this.stateSubject.next(this.insulationMaterialData);
    this.insulationMaterialData = null;
  }

  public editHandlerForSizeData({ sender, rowIndex, dataItem }) {
    this.canAddRowToSizeGrid = false;

    this.sizesOpenedGridRows++;
    this.isSizesGridInChangeMode = true;
    this.currentOpenRow = rowIndex;
    this.formGroup = this.createFormGroupForSizeData(this.insulationMaterialSizeGridData[rowIndex]);
    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandlerForSizeData({ sender, rowIndex }) {
    if (this.isSizesGridInChangeMode) {
      this.sizesOpenedGridRows--;
      sender.closeRow(rowIndex);
      if (this.sizesOpenedGridRows === 0) {
        this.isSizesGridInChangeMode = false;
      }
      this.canAddRowToSizeGrid = true;
    } else {
      this.sizesOpenedGridRows--;
      this.insulationMaterialSizeGridData = this.insulationMaterialSizeGridData.filter(
        item => item !== this.insulationMaterialSizeGridData[rowIndex]
      );
      sender.closeRow(rowIndex);
      this.canAddRowToSizeGrid = true;
    }

  }

  public saveHandlerForSizeData({ sender, formGroup, rowIndex }) {
    this.rowNumber = rowIndex;
    if (this.isSizesGridInChangeMode) {
      if (this.formGroup.valid
      ) {
        this.sizesOpenedGridRows--;

        this.overwriteDataInGrid(rowIndex, formGroup);
        sender.closeRow(rowIndex);
        this.canAddRowToSizeGrid = true;
        if (this.sizesOpenedGridRows === 0) {
          this.isSizesGridInChangeMode = false;
        }
        this.editedSizeData = this.insulationMaterialSizeGridData[rowIndex];
        this.saveEditedSizes();
      }
    } else {
      if (this.formGroup.valid
      ) {
        this.sizesOpenedGridRows--;


        this.overwriteDataInGrid(rowIndex, formGroup);
        sender.closeRow(rowIndex);
        this.canAddRowToSizeGrid = true;
        if (this.sizesOpenedGridRows === 0) {
          this.isSizesGridInChangeMode = false;
        }
        this.editedSizeData = this.insulationMaterialSizeGridData[rowIndex];
        this.saveNewSize();
      }

    }

  }

  public addHandlerForSizeData({ sender }) {
    this.sizesOpenedGridRows++;
    this.insulationMaterialSizeGridData.push(new InsulationMaterialSizeModel(null, null, this.insulationMaterialData.id));
    this.canAddRowToSizeGrid = false;
    this.currentOpenRow = this.insulationMaterialSizeGridData.length - 1;
    sender.editRow(
      this.insulationMaterialSizeGridData.length - 1,
      this.formGroup = this.createFormGroupForSizeData(
        this.insulationMaterialSizeGridData[this.insulationMaterialSizeGridData.length - 1]
      )
    );
  }

  public removeHandler({ sender, dataItem }) {
    this.removeData = dataItem;
  }

  public createFormGroupForSizeData(dataItem: any): FormGroup {
    return this.formBuilder.group({
      _id: dataItem._id,
      id: dataItem.id,
      insulationMaterialId: dataItem.InsulationMaterialId,
      size: new FormControl(dataItem.size, Validators.compose([Validators.required,
      Validators.pattern('^\\d+(?:\\.\\d{1,1})?$')])),
    });
  }

  overwriteDataInGrid(rowIndex, formGroup) {
    this.insulationMaterialSizeGridData[rowIndex].size = formGroup.value.size;
  }

  saveNewSize() {
    console.log(this.editedSizeData);
    this.mainPageService.addNewInsulationMaterialSizeIntoDb(
      JSON.stringify(this.insulationMaterialSizeGridData[this.rowNumber])).subscribe((response) => {
        this.editedSizeData._id = response._id;
        this.editedSizeData.id = response.id;
        this.insulationMaterialSizeGridData[this.rowNumber] = this.editedSizeData;
      });
  }

  saveEditedSizes() {
    console.log(this.insulationMaterialSizeGridData[this.rowNumber]);
    this.mainPageService.updateInsulationMaterialSizeInDb(JSON.stringify(this.editedSizeData)).subscribe((response) => { });
  }

  public removeSize() {
    let index;
    for (let i = 0; i < this.insulationMaterialSizeGridData.length; i++) {
      if (this.insulationMaterialSizeGridData[i]._id === this.removeData._id) {
        index = i;
      }
    }
    this.deleteInsulationMaterialSize(this.insulationMaterialSizeGridData[index]);
  }

  deleteInsulationMaterialSize(size) {
    this.mainPageService.removeInsulationMaterialSize(size._id).subscribe((res) => { }, (error: any) => { });
    this.mainPageService.deleteInsulationMaterialSizeSubject.next(size._id);
  }
}
